<template>
  <div id="estime">
    <v-expansion-panels :disabled="panierUpdating">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div class="mr-2 mr-sm-6 d-flex justify-center align-center">
            <v-icon large class="d-none d-sm-flex mr-0 mr-sm-3">mdi-cart</v-icon>
            <span v-if="!panierUpdating && panier" class="title"> {{ panier.total ? panier.total.prix : 0 | money }}</span>
            <v-skeleton-loader v-if="panierUpdating" type="text" :width="80"></v-skeleton-loader></div
        ></v-expansion-panel-header>
        <v-expansion-panel-content>
          <panier></panier>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import Panier from "@/components/form_parts/Panier"
import { mapGetters } from "vuex"
export default {
  props: {
    sasId: { type: String, required: true }
  },
  components: {
    Panier
  },
  computed: {
    ...mapGetters(["panier", "panierUpdating"])
  }
}
</script>

<style scoped>
#estime {
  position: fixed;
  top: 90px;
  right: 0;
  z-index: 1;
}
</style>